export default "__VITE_ASSET__CXqS5dnr__"